<template>
  <div class="banner">
    <div class="mod-main-tips">
      <el-carousel height="490px" arrow="always">
        <el-carousel-item v-for="item in bannerList" :key="item">
          <img :src="item.qrcode" />
          <p class="title">{{ t(item.name) }}</p>
          <p class="subtitle">{{ t(item.subtitle) }}</p>
          <span class="learn-btn">{{ t('learnmore') }}
            <!-- <el-icon class="topright-btn" :size="20">
              <TopRight />
            </el-icon> -->
          </span>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
  <div class="new-list-bar">
    <h2 class="title">{{ t('menu.about') }}</h2>
    <div class="news-list">
      <div class="left-list">
        <h3>{{ t('fullCompanyname') }}</h3>
        <p>
          {{ t('ltdcontent') }}
        </p>
        <h3>{{ t('fullCompanyname1') }}</h3>
        <p>
          {{ t('ltdcontent1') }}
        </p>
      </div>
      <div class="right-list">
        <img src="../../assets/zl-1.png" />
      </div>
    </div>
  </div>
  <div class="service-bg">
    <div class="el-carousel-warp">
      <h2 class="title">{{ t('menu.myproduct') }}</h2>
      <el-carousel :interval="4000" type="card" height="600px" indicator-position="none">
        <el-carousel-item v-for="item in carouselList" :key="item">
          <img :src="item.qrcode" />
          <p class="carouseltitle">{{ t(item.name) }}</p>
          <p class="carouselsubtitle">{{ t(item.subtitle) }}</p>
          <span class="learn-btn"><router-link class="txt" :to="item.path">{{ t('learnmore') }}</router-link>
          </span>
        </el-carousel-item>
      </el-carousel>
    </div>
  </div>
  <div class="new-list-bar ">
    <h2 class="title">{{ t('menu.service') }}</h2>
    <ul class="serviceList">
      <li v-for="(item, index) in serviceList" :key="item" :class="getClass(index, item)">
        <img class="service-img" :src="item.qrcode" />
        <router-link class="txt" :to="item.path">{{ t(item.name) }}</router-link>
      </li>
    </ul>
  </div>

  <div class="new-list-bar" style="text-align: center;">
    <h2 class="title">{{ t('banner.banner1title') }}</h2>
    <ul class="contact-list">
      <li v-for="(item, index) in coreList" :key="item">
        <span class="serialnum">0{{ index + 1 }}</span>
        <span class="span-icon-box"><img :src="item.qrcode" /></span>
        <span class="span-name">{{ item.name }}</span>
        <span class="span-details">{{ item.details }}</span>
      </li>
    </ul>
  </div>
</template>
<script setup>
import { useI18n } from 'vue-i18n'
import { ref, watch, computed } from "vue";
// import { TopRight } from '@element-plus/icons-vue'
const { t, locale } = useI18n()
const imgurl = ref(require("../../assets/images/circle-2x.png"))
watch(locale, (newValue) => {
  if (newValue === 'zh') {
    console.log('当前语言为中文')
    imgurl.value = require("../../assets/images/circle-2x.png")
  } else if (newValue === 'en') {
    console.log('当前语言为英文')
    imgurl.value = require("../../assets/images/circle-2x1.png")
  }
}, { immediate: true })
const carouselList = ref([
  {
    qrcode: require("../../assets/images/zp-1.jpg"),
    name: 'coreproduct.product.item1title',
    subtitle: 'banner.banner4Subtitle',
    path: "coreproduct/11"
  },
  {
    qrcode: require("../../assets/images/zp-2.jpg"),
    name: 'coreproduct1.product.item1title',
    subtitle: 'coreproduct1.product.item12title',
    path: "coreproduct/12"
  },
  {
    qrcode: require("../../assets/images/zp-3.jpg"),
    name: 'coreproductchildmenu.Intelligent',
    subtitle: 'banner.banner5Subtitle',
    path: "coreproduct/13"
  }
])
const bannerList = ref([
  {
    qrcode: require("../../assets/images/banner-1.png"),
    name: 'banner.banner1title',
    subtitle: 'banner.banner1Subtitle'
  },
  {
    qrcode: require("../../assets/images/banner-2.png"),
    name: 'banner.banner4title',
    subtitle: 'banner.banner4Subtitle',
  },
  {
    qrcode: require("../../assets/images/banner-3.png"),
    name: 'banner.banner3title',
    subtitle: 'banner.banner3Subtitle',
  },
  {
    qrcode: require("../../assets/images/banner-4.png"),
    name: 'banner.banner2title',
    subtitle: 'banner.banner2Subtitle',
  }
])
const serviceList = ref([
  {
    isActive: false,
    qrcode: require("../../assets/images/sy-10.png"),
    name: 'servicechildmenu.service1',
    path: "ourserver-0"
  },
  {
    isActive: false,
    qrcode: require("../../assets/images/sy-11.png"),
    name: 'servicechildmenu.service2',
    path: "ourserver-1"
  },
  {
    isActive: false,
    qrcode: require("../../assets/images/sy-12.png"),
    name: 'servicechildmenu.service3',
    path: "ourserver-2"

  },
  {
    isActive: false,
    qrcode: require("../../assets/images/sy-13.png"),
    name: 'servicechildmenu.service4',
    path: "ourserver-3"
  }
])
const getClass = (index, item) => {
  if (item.isActive === true) {
    return `isActive-${index}`;
  }
};
const coreList = computed(() => [
  {

    name: t('farmList.farmname.name5'),
    details: t('farmList.farmDetails.details5'),
    qrcode: require("../../assets/images/icon1.svg"),
  },
  {
    name: t('farmList.farmname.name6'),
    details: t('farmList.farmDetails.details6'),
    qrcode: require("../../assets/images/icon2.svg"),
  },
  {
    name: t('farmList.farmname.name4'),
    details: t('farmList.farmDetails.details4'),
    qrcode: require("../../assets/images/icon3.svg"),
  },
  {

    name: t('farmList.farmname.name3'),
    details: t('farmList.farmDetails.details3'),
    qrcode: require("../../assets/images/icon4.svg"),
  },
  {
    name: t('farmList.farmname.name1'),
    details: t('farmList.farmDetails.details1'),
    qrcode: require("../../assets/images/icon5.svg"),
  },
  {
    name: t('farmList.farmname.name2'),
    details: t('farmList.farmDetails.details2'),
    qrcode: require("../../assets/images/icon6.svg"),
  },
  {
    name: t('farmList.farmname.name7'),
    details: t('farmList.farmDetails.details7'),
    qrcode: require("../../assets/images/icon7.svg"),

  },
  {
    name: t('farmList.farmname.name8'),
    details: t('farmList.farmDetails.details8'),
    qrcode: require("../../assets/images/icon8.svg"),

  }
])
// const handleMouseOver = (index) => {
//   const newlist = serviceList.value.map((item) => {
//     return { ...item, ...{ isActive: false } };
//   });
//   newlist[index].isActive = true;
//   serviceList.value = newlist;
// };
</script>
<style lang="scss" scoped>
.el-carousel-warp {
  width: 100%;
  padding:0 10px;
  :deep(.el-carousel__arrow) {
    top: 200px;
    width: 40px;
    height: 40px;
    font-size: 20px;
    background-color: rgba(0, 0, 0, 0.3);
    transition: all 0.3s ease;
  } 
  .el-carousel__item img {
    display: block;
    width: 98%;
    height:auto;
  }

  .el-carousel__item .carouseltitle,
  .el-carousel__item .carouselsubtitle,
  .el-carousel__item .learn-btn {
    display: none;
  }

  .is-active img {
    border: 6px solid #f6f6f6
  }

  .is-active .carouseltitle {
    display: block;
    color: #000;
    margin-top: 20px;
    font-weight: bold;
    font-size: 24px;
    text-align: center;
  }

  .is-active .carouselsubtitle {
    display: block;
    color: #000;
    margin-top: 6px;
    font-size: 14px;
    text-align: center;
  }

  .is-active .learn-btn {
    display: block;
    cursor: pointer;
    padding: 0 20px;
    margin: 30px auto 0px;
    width: 100px;
    height: 46px;
    font-size: 16px;
    line-height: 46px;
    text-align: center;
    border: 1px solid #222;
    border-radius: vars.$radius-4;

    &:hover {
      background-color: vars.$base-color;
      color: #fff;
      border: 1px solid vars.$base-color;

      a {
        color: #fff;
      }
    }

    a {
      color: #222;
    }
  }

}

.banner {
  height: 500px;
  margin: 0 auto;

  .mod-main-tips {
    width: 100%;

    img {
      display: block;
      width: 100%;
    }

    p {
      width: 1280px;
      position: absolute;
      text-align: center;
      left: 50%;
      margin-left: -640px;
      color: #fff;
    }

    .title {
      top: 140px;
      font-weight: 600;
      font-size: 40px;
      letter-spacing: 1px;
    }

    .subtitle {
      top: 210px;
      font-size: 18px;
      letter-spacing: 1px;
    }

    .learn-btn {
      cursor: pointer;
      top: 320px;
      padding: 0 40px;
      height: 46px;
      font-size: 16px;
      line-height: 46px;
      position: absolute;
      display: flex;
      justify-content: space-between;
      text-align: center;
      left: 50%;
      border: 1px solid #fff;
      margin-left: -70px;
      color: #fff;
      border-radius: vars.$radius-4;

      &:hover {
        background-color: vars.$base-color;
        color: #fff;
        border: 1px solid vars.$base-color;
      }

      .topright-btn {
        margin-top: 13px;
      }
    }
  }
}

.left-list {
  flex: 2;
  padding: 0px 40px;

  h3 {
    margin: 5px auto;
    font-size: 24px;
  }

  p {
    font-size: 16px;
    line-height: 30px;
  }
}

.right-list {
  flex: 1.8;
  border: 0px;

  img {
    width: 100%;
  }
}

.service-bg {
  background-color: #F6F6F6;
  padding-bottom: 10px;
}

.serviceList {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  li {
    img {
      display: block;
    }

    .txt {
      display: block;
      width: 100%;
      overflow: hidden;
      background-color: #F6F6F6;
      height: 80px;
      line-height: 80px;
      font-size: 18px;
      text-align: center;
      cursor: pointer;
      color: #000;
      border-radius: 0px 0px 8px 8px;

      &:hover {
        color: vars.$base-color
      }
    }
  }
}

.new-img {
  width: 90%;
  margin: 0 auto;
}

.new-list-bar {
  padding-top: 30px;
}

.el-carousel-warp {
  padding-top: 30px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 30px;

  .title {
    padding: 0px 0px 30px 0px;
    font-size: 32px;
    text-align: center;
  }

}

.contact-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 16px;

  li {
    display: flex;
    flex-direction: column;
    width: 306px;
    height: 490px;
    background: #F6F6F6;
    text-align: center;

    span {
      display: block;
    }

    .serialnum {
      width: 30px;
      height: 30px;
      margin-bottom: 40px;
      position: relative;
      top: 10px;
      left: 20px;
      font-size: 32px;
      font-weight: bold;
      color: #c7c7c7
    }

    .span-icon-box {
      margin: 0 auto;
      width: 120px;
      height: 120px;
      border-radius: 60px;
      background-image: linear-gradient(90deg, #1D9A68, #097A44);

      img {
        margin-top: 10px;
        width: 100px;
      }
    }

    .span-name {
      width: 300px;
      margin: 20px auto 0px;
      font-size: 20px;
      font-weight: bold;
    }

    .span-details {
      width: 280px;
      margin: 16px auto 0px;
      font-size: 16px;
      line-height: 24px;
      text-align: left;
      color: #4F4F4F;
    }
  }

}
</style>